import KeenSlider from "keen-slider";

if (document.body.classList.contains("about")) {
	// サムネイル横矢印のprev・next
	let arrowLeft = document.getElementById("arrow-left");
	arrowLeft.addEventListener("click", () => thumbnails.prev());
	let arrowRight = document.getElementById("arrow-right");
	arrowRight.addEventListener("click", () => thumbnails.next());

	function ThumbnailPlugin(main) {
		return (slider) => {
			function removeActive() {
				slider.slides.forEach((slide) => {
					slide.classList.remove("active");
				});
			}
			function addActive(idx) {
				slider.slides[idx].classList.add("active");
			}

			function addClickEvents() {
				slider.slides.forEach((slide, idx) => {
					slide.addEventListener("click", () => {
						main.moveToIdx(idx);
					});
				});
			}

			slider.on("created", () => {
				addActive(slider.track.details.rel);
				addClickEvents();
				main.on("animationStarted", (main) => {
					removeActive();
					const next = main.animator.targetIdx || 0;
					addActive(main.track.absToRel(next));
					slider.moveToIdx(next);
				});
			});
		};
	}
	var slider = new KeenSlider("#my-keen-slider");
	var thumbnails = new KeenSlider(
		"#thumbnails",
		{
			initial: 0,
			slides: {
				perView: 4,
				spacing: 20,
			},
			breakpoints: {
				"(max-width: 1039px)": {
					slides: {
						perView: 3,
						spacing: 25,
					},
				},
				"(max-width: 599px)": {
					slides: {
						perView: 3,
						spacing: 12,
					},
				},
			},
		},

		[ThumbnailPlugin(slider)]
	);
}
